import { render, staticRenderFns } from "./EventList.vue?vue&type=template&id=37f044cd&scoped=true&"
import script from "./EventList.vue?vue&type=script&lang=js&"
export * from "./EventList.vue?vue&type=script&lang=js&"
import style0 from "./EventList.vue?vue&type=style&index=0&id=37f044cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f044cd",
  null
  
)

export default component.exports